export const getServerHost = (): string => {
  if (process.env.REACT_APP_SERVER_HOST) {
    return process.env.REACT_APP_SERVER_HOST
  } else {
    return window.location.host
  }
}
